export default __webpack_public_path__ + "static/media/@jucostareis.b3c5bfb4.jpg";